import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
  monthConfig={
    '0':'Jan',
    '1':'Feb',
    '2':'Mar',
    '3':'Apr',
    '4':'May',
    '5':'Jun',
    '6':'Jul',
    '7':'Aug',
    '8':'Sept',
    '9':'Oct',
    '10':'Nov',
    '11':'Dec'
  }
  transform(value: any, args?: any): any {
    let dateStr = value.split(' ')[0];
    let currentTime = new Date(dateStr);
    var currentOffset = currentTime.getTimezoneOffset();
    var ISTOffset = 330;
    var date = new Date(currentTime.getTime() + (ISTOffset + currentOffset)*60000);
    let day = String(date.getDate());
    let month = date.getMonth();
    let year = date.getFullYear();
    day = day.length>1?day:'0'+day;
    let dateString = "";
    if(args=='dateMonth')
    {
      dateString = day+' '+this.monthConfig[month];
    }
    else
    {
      dateString = day+' '+this.monthConfig[month]+' '+year;
    }
    return dateString;
  }

}
